import { useState, useEffect } from 'react';
import { auth, signInWithGoogle, signOutUser } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';

const ALLOWED_EMAIL = 'phaley@bridgepathsci.com';

export function useAuth() {
  const [user, setUser] = useState(undefined); // undefined = loading
  const [authError, setAuthError] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        if (firebaseUser.email === ALLOWED_EMAIL) {
          setUser(firebaseUser);
          setAuthError(null);
        } else {
          // Wrong account — sign them out immediately
          signOutUser();
          setUser(null);
          setAuthError(`Access denied. This app is private.`);
        }
      } else {
        setUser(null);
      }
    });
    return unsubscribe;
  }, []);

  const login = async () => {
    setAuthError(null);
    try {
      await signInWithGoogle();
    } catch (err) {
      if (err.code !== 'auth/popup-closed-by-user') {
        setAuthError('Sign-in failed. Please try again.');
      }
    }
  };

  return { user, authError, login, logout: signOutUser, loading: user === undefined };
}
